import { render, staticRenderFns } from "./aOwnerDetailAccessControl.vue?vue&type=template&id=20049358&scoped=true"
import script from "./aOwnerDetailAccessControl.vue?vue&type=script&lang=js"
export * from "./aOwnerDetailAccessControl.vue?vue&type=script&lang=js"
import style0 from "./aOwnerDetailAccessControl.vue?vue&type=style&index=0&id=20049358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20049358",
  null
  
)

export default component.exports